import { render, staticRenderFns } from "./MyRequestsTable.vue?vue&type=template&id=2e36296e&scoped=true"
import script from "./MyRequestsTable.vue?vue&type=script&lang=ts"
export * from "./MyRequestsTable.vue?vue&type=script&lang=ts"
import style0 from "./MyRequestsTable.vue?vue&type=style&index=0&id=2e36296e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e36296e",
  null
  
)

export default component.exports